import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

import { Subscription } from 'rxjs';
import { masterConfigurationList } from './constants/masterConfigList';
import { DataService, ServicecallService } from 'src/app/services';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {
  configLoaded: boolean = false;
  private _subscription: Subscription;
  private _routerSubscription: Subscription;
  private _configurationsInfoSubscription: Subscription;

  constructor(private _service: ServicecallService, private _router: Router, private _dataSer: DataService) {
    this._subscription = this._dataSer.events.subscribe((res: any) => {
      if (res.name === 'siteChanged' || res.name === 'apiRefresh' || res.name === 'trackerSiteChanged') {
        setTimeout(() => {
          this._getConfiguration();
        }, 0);
      }
    });
  }

  ngOnInit() {
    this._routerSubscription = this._router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const excludeUrl = ['login', 'signup', 'forgotPassword', 'externalInitialization'];
        const urlSplit = event.url.split('/');
        if (urlSplit.length >= 2 && excludeUrl.includes(urlSplit[1])) {
          this.configLoaded = true;
        }
        if (!this.configLoaded) {
          this._getConfiguration();
        }
      }
    });
  }

  ngOnDestroy(): void {
    this._subscription?.unsubscribe();
    this._routerSubscription?.unsubscribe();
    this._configurationsInfoSubscription?.unsubscribe();
  }

  private _getConfiguration() {
    let mappedConfigList = [];
    this._configurationsInfoSubscription = this._service.configurationsInfo(masterConfigurationList).subscribe({
      next: (data: any) => {
        if (data.status && data.response.length) {
          mappedConfigList = data.response.map((item: any) => {
            const obj = {};
            obj['attribute'] = item.attribute;
            obj['values'] = item.values;
            obj['_id'] = item._id;
            return obj;
          });
          this._service.setConfiguration(mappedConfigList);
        } else {
          this._service.setConfiguration(mappedConfigList);
        }
        this.configLoaded = true;
        if (!mappedConfigList.length) {
          this._service.toasterService({
            type: 'warning',
            msg: 'Configuration list is not available, please provide the required configuration for the app'
          });
        }
      },
      error: (error) => {
        if (error) {
          this.configLoaded = true;
        }
      }
    });
  }
}
